import {createSelector} from '@ngrx/store';

import {IAppState} from '@app/core/store/state/app.state';
import {IScheduleState} from '@app/core/store/state/schedule.state';

const _selectSchedule = (state: IAppState) => state.schedule;

export const selectShifts = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.shifts,
);
export const selectUserShifts = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.userShifts,
);
export const selectIsShiftsLoading = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.isShiftsLoading,
);

export const selectIsShiftUpdating = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.isCreatingUpdatingDeletingShift,
);

export const selectSelectedDates = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.selectedDates,
);
export const selectViewType = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.viewType,
);
export const selectPeriodType = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.periodType,
);
export const selectSelectedStartWeek = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.selectedStartWeek,
);
export const selectGroups = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.groups,
);
export const selectUsers = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.users,
);
export const selectSelectedShift = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.selectedShift,
);
export const selectSelectedDate = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.selectedDate,
);
export const selectIsCopying = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.isCopying,
);
export const selectDraggingShift = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.draggingShift,
);
export const selectAvailabilities = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.availabilities,
);
export const selectSelectedModel = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.selectedModel,
);
export const selectSortingType = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.sortingType,
);
export const selectIsCreatingUpdatingDeletingShift = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.isCreatingUpdatingDeletingShift,
);
export const selectUsersWhoBid = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.usersWhoBid,
);
export const selectScrollLeft = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.scrollLeft,
);

export const selectPrinting = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.printing,
);

export const selectCalculatedDepartmentsIds = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.departmentsIdsCalculated,
);

export const selectHasShiftChanges = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.hasShiftChanges,
);

export const selectLastShiftUpdated = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.lastShiftUpdated,
);

export const selectLastShiftUpdating = createSelector(
	_selectSchedule,
	(state: IScheduleState) => state.lastShiftUpdating,
);
